import React from "react"
import { forwardRef } from "@design-system/core"
import { ModalSheet } from "./ModalSheet"
import { ModalSheetProps } from "./types"

export type SheetProps = Omit<ModalSheetProps, "align" | "isTouch">

export const FullSheet = forwardRef<SheetProps, "div">((props, ref) => (
  <ModalSheet {...props} ref={ref} align="full" isTouch />
))

export const HalfSheet = forwardRef<SheetProps, "div">((props, ref) => (
  <ModalSheet {...props} ref={ref} align="bottom" isTouch />
))

export { ModalHeader as SheetHeader } from "./ModalHeader"
export { ModalBody as SheetBody } from "./ModalBody"
export { ModalFooter as SheetFooter } from "./ModalFooter"
export { ModalCloseButton as SheetCloseButton } from "./ModalCloseButton"
